export const queryKeys = {
  request: (requestId) => ['request', requestId],
  requestComments: (requestId) => ['requestComments', requestId],
  requestAttachments: (requestId) => ['requestAttachments', requestId],
  requestInvitationDays: (requestId) => ['requestInvitationDays', requestId],
  requestInvitationHours: (data) => ['requestInvitationHours', data],
  requestActAvailable: () => ['requestActAvailable'],
  requestExecuters: ({
    houseId = 0,
    addressId = 0,
    serviceId = 0,
    requestId = 0,
    isWarranty = false,
  } = {}) => [
    'requestExecuters',
    houseId,
    addressId,
    serviceId,
    requestId,
    isWarranty,
  ],
  requestHouses: (streetId) => ['requestHouses', streetId],
  requestAddresses: (houseId) => ['requestAddresses', houseId],
  requestStreetsByServiceCompany: (serviceCompanyIds) => [
    'requestStreetsByServiceCompany',
    ...serviceCompanyIds,
  ],
  requestDateModes: () => ['requestDateModes'],
  flatComments: (addressId) => ['flatComments', addressId],
  flatCommentAttachment: ({ addressId, commentId, fileName }) => [
    'flatCommentAttachment',
    addressId,
    commentId,
    fileName,
  ],
  flatAttachment: ({ addressId, fileName }) => [
    'flatCommentAttachment',
    addressId,
    fileName,
  ],
  streetsAvailable: ({ companyId, mode }) => [
    'streetsAvailable',
    companyId,
    mode,
  ],
  housesAvailable: ({ companyId, mode, streetId }) => [
    'housesAvailable',
    companyId,
    mode,
    streetId,
  ],
  checkPermit: ({
    transportId,
    houseId,
    transportPermitTypeId,
    clientId,
    companyId,
    addressId,
  }) => [
    'keyCheckPermit',
    transportId,
    houseId,
    transportPermitTypeId,
    clientId,
    companyId,
    addressId,
  ],
  checkExists: ({ number, region, countryId }) => [
    'checkExists',
    number,
    region,
    countryId,
  ],
  checkCanAddPermit: ({ companyId, clientId, transportPermitTypeId }) => [
    'checkCanAddPermit',
    companyId,
    clientId,
    transportPermitTypeId,
  ],
  checkAddressRemoval: ({ clientId, addressId }) => [
    'checkAddressRemoval',
    clientId,
    addressId,
  ],
};
